import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const VerifyEmailPage = () => {
    const { token } = useParams();
    const [status, setStatus] = useState('verifying'); // verifying | success | error

    useEffect(() => {
        const verify = async () => {
            try {
                await axios.get(`/api/auth/verify/${token}`);
                setStatus('success');
            } catch (err) {
                setStatus('error');
            }
        };
        verify();
    }, [token]);

    return (
        <div style={styles.wrap}>
            <div style={styles.card}>
                {status === 'verifying' && (
                    <>
                        <h1 style={styles.title}>Verifying your email…</h1>
                        <p style={styles.text}>Just a moment.</p>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <h1 style={styles.title}>Email verified ✓</h1>
                        <p style={styles.text}>Your account is fully confirmed. Thanks for joining the movement.</p>
                        <Link to="/" style={styles.btn}>Go to homepage</Link>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <h1 style={styles.title}>This link isn't valid</h1>
                        <p style={styles.text}>It may have already been used, or it's expired. You can request a new one from your account page.</p>
                        <Link to="/account" style={styles.btn}>Go to my account</Link>
                    </>
                )}
            </div>
        </div>
    );
};

const styles = {
    wrap: { minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f0e8' },
    card: { maxWidth: 480, textAlign: 'center', padding: '32px 24px' },
    title: { fontFamily: 'Georgia, serif', fontSize: 24, color: '#1e2a3a', margin: '0 0 12px 0' },
    text: { fontFamily: 'sans-serif', fontSize: 14, color: '#4a5060', lineHeight: 1.6, marginBottom: 20 },
    btn: { display: 'inline-block', background: '#8b1a1a', color: '#f5f0e8', padding: '12px 28px', fontFamily: 'sans-serif', fontSize: 12, letterSpacing: '0.08em', textTransform: 'uppercase', textDecoration: 'none', borderRadius: 3 }
};

export default VerifyEmailPage;